import * as React from 'react';
import { IOfferSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

import { getDealType, isSale } from '../../utils/deal_type';
import { getOfferType, isUrban } from '../../utils/offer_type';

import { AdditionalFeaturesContainer } from '../additional_features/container';
import { FeaturesContainer } from '../features/container';
import { SimilarOffersLinkContainer } from '../similar_offers_link/container';
import { TenantsContainer } from '../tenants/container';

import * as styles from './index.css';

interface IGeneralInformationProps {
  offer: IOfferSchema;
  className?: string;
}

export function GeneralInformation({ className, offer }: IGeneralInformationProps) {
  const dealType = getDealType(offer);
  const offerType = getOfferType(offer);

  return (
    <div className={className}>
      <div className={styles['ab_title']}>Общая информация</div>
      <TenantsContainer />
      {!(isSale(dealType) && isUrban(offerType)) && <FeaturesContainer />}
      <AdditionalFeaturesContainer />
      <SimilarOffersLinkContainer />
    </div>
  );
}
